<template>
  <article>
    <div class="inquiry-top">
        <span class="status-name">{{inquiryInfo.status_name}}</span>
        <span v-if="!isShowStatus && inquiryInfo.match_status !== 0" class="match-status">
          {{inquiryInfo.match_status | showStatus}}
        </span>
    </div>
    <group class="inquiry_info" gutter="0">
      <x-input title='开始时间' disabled v-model="inquiryInfo.started_at"></x-input>
      <x-input title='预计结束' disabled v-model="inquiryInfo.finished_at"></x-input>
      <x-input title='询价时长' disabled v-model="inquiryInfo.enquiry_duration"></x-input>
      <x-input title='报价人次' disabled v-model="inquiryInfo.quote_count"></x-input>
      <x-input title='最低报价' disabled v-model="inquiryInfo.min_quote_price">
        <span slot="right" class="unit">万元</span></x-input>
      <x-input title='平均报价' disabled v-model="inquiryInfo.average_quote_price">
        <span slot="right" class="unit">万元</span></x-input>
      <x-input title='最高报价' disabled v-model="inquiryInfo.max_quote_price" class="red">
        <span slot="right" class="unit">万元</span></x-input>
    </group>
    <group title="报价记录">
      <cell v-for="(item, index) in inquiryInfo.records" :key="index" :title="`${getPrice(item.quote_price)}万元`" @click.native="getDetail(item.dealer_user_id)" class="price-record" :bdStart="true">
        <p slot="after-title" class="detail">报价有效期：{{item.expires_on}}</p>
        <p slot="after-title" class="detail_bule">{{`${item.dealer_user_name} ${item.dealer_user_mobile} ${item.dealer_user_city}`}}</p>
        <div slot="value">{{item.quote_time}}</div>
        <span slot="icon" class="highest_price" v-if="index === 0"></span>
      </cell>
    </group>

    <section class="btn-bottom" v-if="isShow || inquiryInfo.matchable">
      <div v-if="isShow" class="btn-fix">
        <a class="btn" @click.stop="go()">去询价</a>
      </div>

      <flexbox v-if="inquiryInfo.matchable && isMatch"  class="match-time-wrap" justify="space-between">
        <flexbox-item :span="8">
          剩余撮合时间
          <span>
            <clocker :time="inquiryInfo.match_submit_before" slot="value">
              <span class="time-bg">%D</span>天
              <span class="time-bg">%H</span>:
              <span class="time-bg">%M</span>:
              <span class="time-bg">%S</span>
            </clocker>
          </span>
        </flexbox-item>
        <flexbox-item>
          <x-button type="primary"  @click="submitMatch"  class="match-btn">撮合</x-button>
        </flexbox-item>
      </flexbox>

    </section>

  </article>
</template>
<script>
import { Cell, XInput, Group, XButton, Flexbox, FlexboxItem, Clocker } from '@lx-frontend/cvux'
import cache from '../../common/cache'

export default {
  components: {
    Cell,
    XInput,
    Group,
    Flexbox,
    FlexboxItem,
    Clocker,
    XButton
  },
  data() {
    return {
      isShow: false,
      isShowStatus: false, // 控制是否显示右上角状态。
      fromApi: {
        inquiry: 'used_car/ticket/enquiry', // 线索询价撮合
        auction: 'auctions/auction_car_enquiries' // 车辆询价撮合
      },
      source: '',
      isMatch: false, // 控制显示撮合按钮
      inquiryInfo: {}
    }
  },
  created() {
    let id = this.$route.params.id
    // source的值为 inquiry 表示线索询价，auction 表示 为车辆询价
    this.source = this.$route.params.source
    // 用于区别是否能够点击撮合按钮。线索询价栏目过来不能点击 ，车辆撮合选择、询价撮合栏目过来的可以
    this.isMatch = this.$route.query.match || false
    let urlLeft = `${this.fromApi[this.source]}/${id}`
    this.$rest.inquiry.getEnquiryInfo(null, urlLeft).then((res) => {
      if (res.code === 0) {
        let needBtn = +this.$route.query.need_btn
        this.inquiryInfo = this.getNewInfo(res.data)
        // 用于控制是否显示底部状态
        if (needBtn || this.inquiryInfo.is_support_enquiry) {
          this.isShow = true
        }
        // 说明是从线索过来的。不需要显示右上角的状态
        if (needBtn) {
          this.isShowStatus = true
        }
      } else {
        this.showToast(res.message)
      }
    })
  },
  methods: {
    getNewInfo(info = {}) {
      info.quote_count = `${info.quote_count}人`
      info.min_quote_price = this.getPrice(info.min_quote_price)
      info.average_quote_price = this.getPrice(info.average_quote_price)
      info.max_quote_price = this.getPrice(info.max_quote_price)
      return info
    },
    getPrice(value) {
      return (value / 1000000).toFixed(2) || '--'
    },
    getDetail(id) {
      this.$router.push({ path: `/auction/detail/${id}` })
    },
    go() {
      cache.clearSessionData('queryForm')
      // 线索发起询价是ticket_id, 车辆发起询价需要auction_car_id
      let id = this.inquiryInfo.ticket_id || this.inquiryInfo.auction_car_id
      this.$router.push({ path: `/inquiry/submit/${id}/${this.source}` })
    },
    submitMatch() {
      // 询价撮合也要区分是车辆询价的撮合、还是线索询价的撮合
      let source = this.source
      // 跳转到提交撮合页面
      this.$router.push({ path: `/auction/match/submit/${this.inquiryInfo.enquiry_id}`, query: { type: 'enquiry', source: source } })
    }
  },
  filters: {
    showStatus(matchStatus) {
      let result = ''
      switch (matchStatus) {
        case 1:
          result = '待车商确认'
          break
        case 2:
          result = '待收款'
          break
        case 3:
          result = '已成交'
          break
        case 4:
          result = '已拒绝'
          break
        case 5:
          result = '已关闭'
          break
      }
      return result
    }
  }
}

</script>
<style lang="less">
@import "../../stylesheets/modules/inquiry/inquiryInfo.less";
.match-time-wrap {
  position: fixed;
  bottom: 0;
  padding: 15/@w2 30/@w2;
  border-top: 1px solid #eee;
  box-sizing: border-box;
  z-index: 999;
  background-color: #fff;
  .time-bg {
    display: inline-block;
    padding: 5/@w2 6/@w2;
    border-radius: 3px;
    color: #fff;
    background-color: #5e5e5e;
  }
  .match-btn {
    width: 218/@w2;
    margin-right: 0;
  }
}
</style>
